export default __webpack_public_path__ + "static/media/arena_2.460d8875.jpeg";